import { createContext, useContext } from "react";
import type { SubagentEvent } from "~/components/assistant-v2/SubagentActivity";

// Subagent events context — provided by the conversation runtime, consumed by
// DefaultToolMessage to render real-time progress inside parent tool cards.
const EMPTY_MAP = new Map<string, SubagentEvent[]>();
const SubagentEventsContext = createContext<Map<string, SubagentEvent[]>>(EMPTY_MAP);

export const SubagentEventsProvider = SubagentEventsContext.Provider;

export function useSubagentEventsForTool(toolCallId: string): SubagentEvent[] {
  const map = useContext(SubagentEventsContext);
  return map.get(toolCallId) ?? [];
}
